<template>
  <form class="dashboard-block">
    <h2>Change Password</h2>
    <div class="panel panel-grey">
      <div class="panel-body">
        <div class="form-horizontal">
          <div class="row">
            <div class="col-md-6">
              <div class="form-group" :class="{ 'has-error' : errorMessages.password }">
                <label class="control-label col-sm-4">New Password:</label>
                <div class="col-sm-8">
                  <input
                    name="password"
                    type="password"
                    class="form-control"
                    v-model="password">

                  <span class="help-block" v-if="errorMessages.password">{{ errorMessages.password }}</span>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group" :class="{ 'has-error' : errorMessages.passwordConfirmation }">
                <label class="control-label col-sm-4">Repeat:</label>
                <div class="col-sm-8">
                  <input
                    name="password_confirmation"
                    type="password"
                    class="form-control"
                    v-model="passwordConfirmation">

                  <span class="help-block" v-if="errorMessages.passwordConfirmation">{{ errorMessages.passwordConfirmation }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="panel-footer">
        <ladda-button
          type="submit"
          class="btn btn-sm btn-primary"
          :click="handleChangePasswordCallback"
          :disabled="userIsAdmin && !canEditAdmin">
          Change Password
        </ladda-button>
      </div>
    </div>
  </form>
</template>

<script>
import { helpers } from 'mixins/users'
import { mapActions, mapState } from 'vuex'
import { notify } from 'utils'

import {required, sameAs, minLength, helpers as validationHelpers} from 'vuelidate/lib/validators'

export default {
  mixins: [helpers],

  data () {
    return {
      password: null,
      passwordConfirmation: null
    }
  },

  validations: {
    password: {
      required,
      minLength: minLength(6),
      passwordRules: validationHelpers.regex('passwordRules', /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{6,}$/)
    },
    passwordConfirmation: {
      sameAsPassword: sameAs('password')
    }
  },

  computed: {

    ...mapState('user', ['user']),

    errorMessages () {
      let errors = {}

      const messages = {
        password: {
          required: 'A password is required.',
          minLength: 'Passwords must be at least 6 characters.',
          passwordRules: 'Password must contain a lowercase letter, an uppercase letter and a number.'
        },
        passwordConfirmation: {
          sameAsPassword: 'The password confirmation field does not match.'
        }
      }

      if (!this.$v.$error) { return errors }

      for (const [field, fieldMessages] of Object.entries(messages)) {
        if (!this.$v[field] || !this.$v[field].$invalid) continue

        for (const [rule, ruleMessage] of Object.entries(fieldMessages)) {
          if (this.$v[field][rule] === false) {
            errors[field] = ruleMessage
            break
          }
        }
      }

      return errors
    }

  },

  methods: {
    ...mapActions('user', ['updateUserPassword']),

    /**
     * Handle changing the users password.
     *
     * Validate the data before sending.
     *
     * @return Promise
     */
    handleChangePasswordCallback () {
      if (this.$v.$invalid) {
        this.$v.$touch()
        notify.error(`Some fields failed validation. Please fix them and try again`)
        return Promise.reject(new Error('Data invalid'))
      }

      return this.updateUserPassword({
        id: this.user.id,
        payload: {
          password: this.password,
          password_confirmation: this.passwordConfirmation
        }
      })
        .then(() => {
          this.password = null
          this.passwordConfirmation = null
          notify.success('Successfully changed password.')
        })
        .catch((error) => {
          if (error.response) {
            notify.error(error.response.data.message)
          } else {
            notify.error('Sorry something has gone wrong, please try again.')
            throw error
          }
        })
    }
  }
}
</script>
